import styled from 'styled-components';
import { Link } from '@experian-uk/corvetteuk-common-ui';

export default styled(Link.Anchor)`
  font-size: inherit;
  font-weight: 300;
`;
